import React from "react";
import { useAuth } from "../contexts/AuthContext";
import SlideCard from "./SlideCard";
import "./Dashboard.css";

const Dashboard = () => {
  const { user } = useAuth();
  // Sample slide deck data
  const slideDecks = user.assigned_clients;

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="header-content">
          <div className="header-text">
            <h1>Welcome, {user?.email.split("@")[0].slice(0, -1)}</h1>
            <p className="header-subtitle">Legal Portal Dashboard</p>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="welcome-section">
          {/* <div className="scales-icon">⚖️</div> */}
          <h3>Assigned Clients</h3>
          <p>See the list of clients assigned to you.</p>
        </div>

        <div className="slide-cards-container">
          {slideDecks.map((deck) => (
            <SlideCard
              key={deck.id}
              deck={deck}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
